import { styled } from "@mui/material";
import AddLink from "controls/global/add-link";
import React from "react";
import { useProfileSettingsCache } from "utils/context/ProfileSettingsContext";
import { PERMISSIONS } from "utils/data/enum";

const LinkContainer = styled("div")({
  marginRight: "auto",
});

interface AddSignatureLinkProps {
  onClick: () => void;
}

export default function AddSignatureLink({
  onClick,
}: AddSignatureLinkProps) {
  const [{ profileSettings }] = useProfileSettingsCache();

  const permissionCodes = profileSettings?.userPermissionItemTypes as string[];
  const hasAddSignatureAccess =
    permissionCodes?.includes(PERMISSIONS.SIGNATURES_ADD);

  return (
    <LinkContainer>
      <AddLink
        disabled={!hasAddSignatureAccess}
        onClick={onClick}
      >
        Add Signature
      </AddLink>
    </LinkContainer>
  );
}
